export class ConnectNativePageRequestModel {
  childPageId: number;
  projectedPageId: number;

  constructor() {
    this.childPageId = null;
    this.projectedPageId = null;
  }
}
